import { render, staticRenderFns } from "./f2g-text-field.vue?vue&type=template&id=1f53c9c2&scoped=true"
import script from "./f2g-text-field.vue?vue&type=script&lang=js"
export * from "./f2g-text-field.vue?vue&type=script&lang=js"
import style0 from "./f2g-text-field.vue?vue&type=style&index=0&id=1f53c9c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53c9c2",
  null
  
)

export default component.exports